module.exports = __webpack_public_path__ + "static/PureLeaf_LeavesPromo-2ca813ace40442af2519cda76eb09b67.jpg";